// Central content sourced from the DNA eCommerce Ads 2026 deck.

export const CONTACT = {
  email: "hello@amazonads.co.in",
  phone: "+91 98733 62362",
  phoneHref: "+919873362362",
  location: "WeWork Berger Delhi One, Floor 19, Sector 16B, Noida, UP 201301",
};

export const IMPACT_METRICS = [
  { value: "11.4x", label: "Peak ROAS achieved", sub: "STIM — up from 3.8x in 8 months", accent: "orange" },
  { value: "+68%", label: "Revenue growth", sub: "₹14.7L → ₹24.7L for STIM", accent: "magenta" },
  { value: "1 Lakh+", label: "Products sold", sub: "Across marketplaces, FY24–25", accent: "indigo" },
  { value: "6.24x", label: "Amazon DSP ROAS", sub: "Michelin France — €44.2K on €7.1K", accent: "orange" },
  { value: "10x", label: "DSP returns delivered", sub: "Across eCommerce campaigns", accent: "magenta" },
  { value: "2x", label: "Order volume", sub: "4,819 → 10,092 orders", accent: "indigo" },
];

export const SERVICES = [
  {
    no: "01",
    title: "Amazon Ads Management",
    desc: "Sponsored Products, Brands & Display plus full-funnel Amazon DSP — engineered around a self-cleaning campaign structure that lowers TACoS as you scale.",
    points: ["Sponsored Ads restructuring", "Amazon DSP & AMC strategy", "Keyword harvesting & bid control", "Budget efficiency & TACoS management"],
  },
  {
    no: "02",
    title: "A+ Content Creation",
    desc: "Conversion-first A+ content, brand stores and catalogue creatives that answer objections in the order shoppers think of them.",
    points: ["Premium A+ / brand story modules", "Comparison & spec charts", "Amazon storefront design", "Marketplace-ready product imagery"],
  },
  {
    no: "03",
    title: "Performance Marketing",
    desc: "Media that works harder — traffic quality, listing performance, conversion and sales efficiency brought into one connected growth system.",
    points: ["Full-funnel media planning", "Listing & SEO optimization", "Retargeting & new-to-brand growth", "Analytics & conversion tracking"],
  },
];

export const CASE_STUDIES = [
  {
    id: "stim",
    client: "STIM Oral Care",
    tag: "eCommerce Marketing",
    accent: "orange",
    image: "https://images.unsplash.com/photo-1607613009820-a29f7bb81c04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    summary: "Scale Amazon India sales and hit a ROAS of 5 in six months — despite low visibility, high ACOS and weak engagement.",
    context:
      "STIM, an oral-care brand established in 1965, was stuck with low organic visibility, a high advertising cost of sales, and limited customer engagement on Amazon India. The mandate: accelerate marketplace growth and prove advertising efficiency within months, not years.",
    approach: ["Revamped listings & SEO", "Interactive A+ content", "Restructured underperforming campaigns", "Creative aligned to product pages"],
    timeline: [
      { no: "01", title: "Audit", desc: "Deep listing, keyword and campaign audit surfaced high ACOS and thin organic visibility." },
      { no: "02", title: "Rebuild", desc: "Revamped listings with SEO and interactive A+ content; killed wasteful campaigns." },
      { no: "03", title: "Harvest", desc: "Shifted budget to proven, high-converting keywords and tightened bids." },
      { no: "04", title: "Scale", desc: "Compounded the winners — ROAS climbed to 11.4x while TACoS fell to 8.8%." },
    ],
    chart: {
      type: "beforeAfter",
      metrics: [
        { label: "ROAS", before: 3.8, after: 11.4, suffix: "x" },
        { label: "TACoS", before: 15.3, after: 8.8, suffix: "%", lowerBetter: true },
        { label: "Monthly Sales", before: 14.7, after: 24.7, suffix: "₹L" },
        { label: "Orders", before: 4819, after: 10092, suffix: "" },
      ],
    },
    results: [
      { k: "ROAS", v: "3.8x → 11.4x", note: "3x growth in 8 months" },
      { k: "Sales", v: "₹14.7L → ₹24.7L", note: "+68% revenue" },
      { k: "TACoS", v: "15.3% → 8.8%", note: "43% more efficient" },
      { k: "Orders", v: "4,819 → 10,092", note: "2x volume" },
    ],
  },
  {
    id: "cambridge",
    client: "Cambridge Audio",
    tag: "Full-Funnel DSP",
    accent: "magenta",
    image: "https://images.pexels.com/photos/18924580/pexels-photo-18924580.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    summary: "Prove Amazon DSP's full-funnel contribution for a long purchase-cycle premium audio brand at risk of cutting DSP.",
    context:
      "Cambridge Audio sells high-value hi-fi equipment with a long purchase cycle. DSP was undervalued on last-click ROAS and at risk of being cut. We needed to prove its true full-funnel contribution before the budget disappeared.",
    approach: ["DSP + Sponsored Ads mix", "Amazon Marketing Cloud analysis", "Shopper journey & overlap mapping", "Budget reallocation"],
    timeline: [
      { no: "01", title: "Diagnose", desc: "Mapped the real shopper journey and ad overlap with Amazon Marketing Cloud." },
      { no: "02", title: "Full-funnel", desc: "Combined DSP with Sponsored Ads across awareness, consideration and conversion." },
      { no: "03", title: "Reallocate", desc: "Moved budget toward the paths that initiated new-to-brand demand." },
      { no: "04", title: "Prove", desc: "Attributed 81% of sales to DSP and grew the customer base by 48%." },
    ],
    chart: {
      type: "bars",
      unit: "%",
      metrics: [
        { label: "Sales via DSP", value: 81 },
        { label: "New-to-brand", value: 60 },
        { label: "Customer base", value: 48 },
        { label: "Sales uplift", value: 19 },
      ],
    },
    results: [
      { k: "DSP influence", v: "81%", note: "of total sales" },
      { k: "New-to-brand", v: "60%", note: "of DSP orders" },
      { k: "Sales uplift", v: "+19%", note: "overall" },
      { k: "Customer base", v: "+48%", note: "increase" },
    ],
  },
  {
    id: "zerowater",
    client: "ZeroWater",
    tag: "Competitive Acquisition",
    accent: "indigo",
    image: "https://images.unsplash.com/photo-1587800387687-60c1e4d08c9d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    summary: "Hit a first-month ROAS target and outperform category leader BRITA in a fiercely competitive filtration category.",
    context:
      "ZeroWater entered a crowded water-filtration category dominated by BRITA. The goal was aggressive but clear: hit a ROAS target in the very first month and win share directly from the category leader.",
    approach: ["High-intent retargeting", "Amazon DSP precision targeting", "Messaging vs. BRITA", "Real-time bid optimization"],
    timeline: [
      { no: "01", title: "Target", desc: "Built high-intent and competitor-conquesting audiences around BRITA shoppers." },
      { no: "02", title: "Launch", desc: "DSP-led execution with sharp messaging on ZeroWater's 5-stage advantage." },
      { no: "03", title: "Optimize", desc: "Real-time bid optimization tuned directly against ROAS targets." },
      { no: "04", title: "Win", desc: "Hit the first-month ROAS target and outperformed BRITA on conversion." },
    ],
    chart: null,
    results: [
      { k: "ROAS", v: "Target hit", note: "in month one" },
      { k: "vs. BRITA", v: "Outperformed", note: "on conversion" },
      { k: "Acquisition", v: "Faster", note: "customer growth" },
      { k: "Foundation", v: "Strong", note: "early campaign base" },
    ],
  },
  {
    id: "michelin",
    client: "Michelin France",
    tag: "Amazon DSP",
    accent: "orange",
    image: "https://images.pexels.com/photos/10467348/pexels-photo-10467348.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    summary: "Scale efficiently beyond Sponsored Ads with Amazon DSP while protecting profitability in the French marketplace.",
    context:
      "Michelin France wanted to grow beyond the ceiling of Sponsored Ads without sacrificing profitability. Amazon DSP was the lever — but only if it could scale sales efficiently and hold a strong return.",
    approach: ["DSP activation & audience expansion", "Advanced targeting & remarketing", "Weekly monitoring & optimization", "Balanced budget allocation"],
    timeline: [
      { no: "01", title: "Expand", desc: "Activated Amazon DSP to reach demand beyond Sponsored Ads." },
      { no: "02", title: "Target", desc: "Layered advanced audience targeting and remarketing." },
      { no: "03", title: "Monitor", desc: "Weekly optimization and disciplined budget balancing." },
      { no: "04", title: "Scale", desc: "Delivered 6.24x ROAS — €44.2K in sales from €7.1K of spend." },
    ],
    chart: {
      type: "bars",
      unit: "K€",
      metrics: [
        { label: "Ad Spend", value: 7.1 },
        { label: "Sales", value: 44.2 },
      ],
      highlight: { label: "ROAS", value: "6.24x" },
    },
    results: [
      { k: "ROAS", v: "6.24x", note: "strong return" },
      { k: "Sales", v: "€44.2K", note: "from €7.1K spend" },
      { k: "Return", v: "6x+", note: "on spend" },
      { k: "Growth", v: "High-ROI", note: "beyond Sponsored Ads" },
    ],
  },
];

export const WORK_SAMPLES = [
  { img: "/work-samples/page-07.jpg", brand: "Bionutrica", type: "A+ Content" },
  { img: "/work-samples/page-08.jpg", brand: "Bionutrica", type: "Catalogue Creatives" },
  { img: "/work-samples/page-10.jpg", brand: "Bionutrica", type: "Amazon Storefront" },
  { img: "/work-samples/page-12.jpg", brand: "Laboratorie Bioreva", type: "A+ Content" },
  { img: "/work-samples/page-14.jpg", brand: "Laboratorie Bioreva", type: "Amazon Storefront" },
  { img: "/work-samples/page-16.jpg", brand: "Cambridge Audio", type: "A+ Content" },
  { img: "/work-samples/page-18.jpg", brand: "Cambridge Audio", type: "Amazon Storefront" },
  { img: "/work-samples/page-20.jpg", brand: "Cetaphil", type: "A+ Content" },
  { img: "/work-samples/page-22.jpg", brand: "Cetaphil", type: "Amazon Storefront" },
  { img: "/work-samples/page-24.jpg", brand: "STIM", type: "A+ Content" },
  { img: "/work-samples/page-26.jpg", brand: "STIM", type: "Amazon Storefront" },
  { img: "/work-samples/page-28.jpg", brand: "ZeroWater", type: "A+ Content" },
  { img: "/work-samples/page-30.jpg", brand: "ZeroWater", type: "Amazon Storefront" },
  { img: "/work-samples/page-32.jpg", brand: "Chitshakti", type: "Amazon Storefront" },
];

export const CLIENTS = [
  "Cetaphil", "Michelin", "Sunstar", "GUM", "Bionutrica", "Bioreva",
  "KSM Hair", "Chitshakti", "Timberland", "Skyntox", "STIM", "ZeroWater", "Cambridge Audio",
];

export const TESTIMONIALS = [
  {
    quote:
      "They helped us scale performance significantly, improving ROAS to 8 within the first 3 months and further elevating it to 11.4 over the following 8 months. A team that combined strategy with action.",
    name: "Viren Khuller",
    role: "Director — STIM",
  },
  {
    quote:
      "Over two years, DJ mastered Amazon DSP, Google Ads, Meta Ads, Google Shopping and Bing campaigns, consistently delivering outstanding performance. A true Digital Marketing expert.",
    name: "Anders Hjorth",
    role: "e-Comas, Germany",
  },
  {
    quote:
      "Catapulted visibility of the Analytics Hive brand to levels we never imagined. We started getting higher quality in-bound leads which enriched our pipeline immensely.",
    name: "Justice Chikomba",
    role: "Founder — Analytics Hive",
  },
  {
    quote:
      "A great, reactive, friendly and efficient team — very complete with many types of knowledge and a sharp, wise kind of digital media practice. We'd recommend them to anyone.",
    name: "Jérôme de Guigné",
    role: "e-Comas, Germany",
  },
];

export const BLOG_CATEGORIES = ["All", "Amazon Strategy", "A+ Content Tips", "PPC Updates"];

export const CATEGORY_COLOR = {
  "Amazon Strategy": "text-orange border-orange/40",
  "A+ Content Tips": "text-magenta border-magenta/40",
  "PPC Updates": "text-indigo-bright border-indigo-bright/40",
};
